const titlesList = ['Sir', "Ma'am", 'Madam', 'Mr', 'Mrs', 'Ms', 'Miss', 'Dr', 'Professor'];

export default titlesList;
